import { createContext } from 'react';
import type { Sesion, Usuario } from './puerto';

export interface SesionContextValue {
  /** `null` = no hay sesión. Para «todavía no se sabe» está `rehidratando`. */
  sesion: Sesion | null;
  usuario: Usuario | null;
  /**
   * Cierto mientras se lee la sesión guardada, al montar.
   *
   * Es la distinción que evita el parpadeo del guardia: sin ella, el primer
   * render dice «no hay sesión» y el guardia manda al acceso a alguien que sí
   * la tiene. No es cosmético —la URL cambia— y es de los errores que sólo se
   * ven al recargar una ruta profunda, no navegando hacia ella.
   */
  rehidratando: boolean;
  /** Si el adaptador montado es una simulación. Enciende el aviso. */
  esDeMentira: boolean;
  iniciarSesion: (correo: string, contrasena: string) => Promise<void>;
  cerrarSesion: () => Promise<void>;
  /**
   * Pide un código de recuperación.
   *
   * Resolver **no significa que el correo haya salido**: el servidor contesta
   * lo mismo exista o no la cuenta, que es lo que impide enumerar correos. La
   * pantalla tiene que hablar en condicional.
   */
  pedirCodigo: (correo: string) => Promise<void>;
  restablecer: (correo: string, codigo: string, contrasena: string) => Promise<void>;
}

/**
 * Sin proveedor **lanza**, al revés que `I18nContext`.
 *
 * Allá hay una respuesta por omisión razonable —español— y aquí no la hay: si
 * una pantalla del área se monta sin proveedor, lo correcto no es decidir que
 * no hay sesión, es avisar de que falta el proveedor. Un `null` silencioso se
 * vería igual que «no has entrado» y mandaría a la gente al acceso por un error
 * de montaje.
 */
export const SesionContext = createContext<SesionContextValue | null>(null);
